import React, { useEffect, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import {
  ConsoleLogger,
  DefaultDeviceController,
  LogLevel,
} from 'amazon-chime-sdk-js';
import { useDispatch, useSelector } from 'react-redux';
import {
  setAudioDevice,
  setMicDevice,
} from 'src/redux/actions/teleTherapyActions';
import AudioSettings from './AudioSettings';
import VideoSettings from './VideoSettings';
import { SettingsType } from './constant';
import iconClose from 'src/assets/icons/icon-close.svg';
import './settings-modal.scss';

interface SettingsModalProps {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
}

const SettingsModal2: React.FC<SettingsModalProps> = ({showModal, setShowModal}) => {
  const [activeTab, setActiveTab] = useState<'video' | 'audio'>(
    SettingsType.VIDEO,
  );
  const dispatch = useDispatch();
  const { micDevice, audioDevice } = useSelector(
    ({ teleTherapy }: any) => teleTherapy,
  );
  let deviceController: any;
  const [audioDevices, setAudioDevices] = useState<MediaDeviceInfo[]>([]);
  const [videoDevices, setVideoDevices] = useState<MediaDeviceInfo[]>([]);
  const [audioOutputDevices, setAudioOutputDevices] = useState<
    MediaDeviceInfo[]
  >([]);
  const deviceControllerRef = useRef<DefaultDeviceController | null>(null);

  useEffect(() => {
    init();

    return () => {
      deviceControllerRef.current?.destroy();
      deviceControllerRef.current = null;
    };
  }, []);

  const init = async () => {
    deviceController = new DefaultDeviceController(
      new ConsoleLogger('DeviceController', LogLevel.OFF),
    );

    deviceControllerRef.current = deviceController;

    const audioDevices = await deviceController.listAudioInputDevices();
    const videoDevices = await deviceController.listVideoInputDevices();
    const audioOutputDevices = await deviceController.listAudioOutputDevices();

    setAudioDevices(audioDevices);
    setVideoDevices(videoDevices);
    setAudioOutputDevices(audioOutputDevices);

    applyDefaultAudioDevices(audioDevices, audioOutputDevices);
  };

  // Nothing is selected until the user picks a device, which leaves the audio
  // dropdowns blank on first open. Fall back to the first device of each kind.
  const applyDefaultAudioDevices = (
    audioInputDevices: MediaDeviceInfo[],
    audioOutputDevices: MediaDeviceInfo[],
  ) => {
    if (!micDevice && audioInputDevices?.length) {
      dispatch(setMicDevice(audioInputDevices[0]));
    }

    if (!audioDevice && audioOutputDevices?.length) {
      dispatch(setAudioDevice(audioOutputDevices[0]));
    }
  };

  return (
    <Modal
      backdrop="static"
      show={showModal}
      dialogClassName="settings-modal modal-60w modal-60h"
      size="lg"
      centered={true}
    >
      <Modal.Header
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
        }}
      >
        <Modal.Title className="d-flex">Call Settings</Modal.Title>

        <img
          className='close-btn'
          onClick={() => setShowModal(false)}
          src={iconClose}
          alt='close modal' />
      </Modal.Header>

      <Modal.Body style={{ backgroundColor: '#f0f2f8' }}>
        <div className="settings-modal">
          <div className="header-tab">
            <div
              className={`tab ${
                activeTab === SettingsType.VIDEO ? 'active' : ''
              }`}
              onClick={() => setActiveTab(SettingsType.VIDEO)}
            >
              Video
            </div>
            <div
              className={`tab ${activeTab === 'audio' ? 'active' : ''}`}
              onClick={() => setActiveTab(SettingsType.AUDIO)}
            >
              Audio
            </div>
            <div
              className="active-indicator"
              style={{ left: activeTab === SettingsType.VIDEO ? '38%' : '51%' }}
            />
          </div>
          <div className="content">
            {activeTab === SettingsType.VIDEO ? (
              <VideoSettings videoDevices={videoDevices} />
            ) : (
              <AudioSettings
                deviceController={deviceControllerRef.current}
                audioDevices={audioDevices}
                audioOutputDevices={audioOutputDevices}
              />
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SettingsModal2;
